import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";
import { integrationsHttp } from "./integrations-http";

const cacheKeys = {
  integrations: "integrations",
  integrationProviders: "integration-providers",
  integration: "integration",
};

export const useGetIntegrations = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery(
    [cacheKeys.integrations],
    () => integrationsHttp.getIntegrations(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};

export const useGetIntegration = (
  organizationKeyName: OrganizationKeyName,
  id?: string
) => {
  return useQuery(
    [cacheKeys.integration, id],
    () => integrationsHttp.getIntegration(organizationKeyName, id),
    { refetchOnWindowFocus: false, enabled: !!id }
  );
};

export const useGetIntegrationProviders = (
  organizationKeyName?: OrganizationKeyName
) => {
  return useQuery(
    [cacheKeys.integrationProviders],
    () => integrationsHttp.getIntegrationProviders(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};

export const useCreateIntegration = () => {
  const queryClient = useQueryClient();
  return useMutation(integrationsHttp.createIntegration, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.integrations]);
    },
  });
};

export const useUpdateIntegration = () => {
  const queryClient = useQueryClient();
  return useMutation(integrationsHttp.updateIntegration, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.integrations]);
    },
  });
};

export const useDeleteIntegration = () => {
  const queryClient = useQueryClient();
  return useMutation(integrationsHttp.deleteIntegration, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.integrations]);
    },
  });
};
